import { atom } from 'jotai';

// Our Constants
import {
	DEFAULT_KEY_ACTION_RATE,
	DEFAULT_KEY_ACTION_DATE
} from 'shared/constants/KeyActions/KeyActionTypes';

const keyActionQualifierAtom = atom({
	mortgageRateQualifier: `${DEFAULT_KEY_ACTION_RATE}`,
	mortgageOriginationDateQualifier: DEFAULT_KEY_ACTION_DATE
});

// Derived atoms for individual fields
export const mortgageRateQualifierAtom = atom(
	(get) => get(keyActionQualifierAtom).mortgageRateQualifier,
	(get, set, newValue) => {
		const current = get(keyActionQualifierAtom);
		set(keyActionQualifierAtom, {
			...current,
			mortgageRateQualifier: newValue
		});
	}
);

export const mortgageOriginationDateQualifierAtom = atom(
	(get) => get(keyActionQualifierAtom).mortgageOriginationDateQualifier,
	(get, set, newValue) => {
		const current = get(keyActionQualifierAtom);
		set(keyActionQualifierAtom, {
			...current,
			mortgageOriginationDateQualifier: newValue
		});
	}
);

export default keyActionQualifierAtom;
